export const ReviewLoading = ({ onBack }) => {
  return (
    <>
      <header className="review-header px-2 pb-2">
        <div className="review-header-panel search-bar bg-green">
          <div className="row g-2 align-items-center">
            <div className="col-2 text-start">
              <button className="btn bg-beige" type="button" onClick={onBack}>
                <i className="bi bi-arrow-left" />
              </button>
            </div>
            <div className="col-8 text-center">
              <span className="review-header-label">Review Images</span>
              <h5 className="review-header-title">Loading...</h5>
            </div>
            <div className="col-2">
            </div>
          </div>
        </div>
      </header>
      <div className="text-center mx-2 p-4">
        <div className="spinner-border text-success mb-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Loading images...</p>
      </div>
    </>
  );
}

